import { Component, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Expediente } from "@models/expediente.model";
import { Licencia } from "@models/licencia.model";
import { SessionService } from "@services/session.service";
import { StateService } from "@services/state.service";
import { TerminologiaService } from "@services/terminologia.service";
import ExpedienteEstados from "@shared/enums/expediente-estados.enum";
import Funcionalidades from "@shared/enums/funcionalidades.enum";
import { Mensajes } from "@shared/enums/mensajes.enum";
import Roles from "@shared/enums/roles.enum";
import { obtenerCantidadDias } from "@shared/utils/date.utils";
import sprintf from "@shared/utils/sprintf.util";

@Component({
	selector: "app-header-expediente",
	templateUrl: "./header-expediente.component.html",
	styleUrls: ["./header-expediente.component.scss"],
})
export class HeaderExpedienteComponent {
	@Input() Expediente: Expediente;
	@Input() Licencia: Licencia;
	@Input() verSancion: boolean;

	constructor(
		protected sessionService: SessionService,
		protected route: ActivatedRoute,
		private stateService: StateService,
		private terminologiaService: TerminologiaService,
	) {}

	get mensajeDiasRestantes(): string {
		if (!this.Expediente) return;
		const mensaje = this.terminologiaService.obtenerMensajePorID(
			this.diasRestantes < 1
				? Mensajes.dias_habiles_agotados
				: Mensajes.dias_habiles_restantes,
		);
		return sprintf(mensaje, this.diasRestantes);
	}

	get diasRestantes(): number {
		const hoy = new Date(); // Fecha actual
		const limite = new Date(this.Expediente.fecha_termino); // Fecha límite
		const dias = obtenerCantidadDias(limite, hoy);
		return dias < 0
			? dias
			: (this.stateService.getExpediente().dias_habiles ?? -1);
	}

	get esHistorial(): boolean {
		// Obtener funcionalidad desde el router
		const idFuncionalidad = this.route.snapshot.data["funcionalidad"];
		return idFuncionalidad === Funcionalidades.revisar_expedientes_historial;
	}

	get esPerfilCorrectoDiasRestantes(): boolean {
		const idRol = this.sessionService.rolActual;
		switch (idRol) {
			case Roles.creador_expediente:
				return [
					ExpedienteEstados.apelacion_suseso,
					ExpedienteEstados.apelacion_aprobada,
					ExpedienteEstados.apelacion_rechazada,
					ExpedienteEstados.resolucion_apelada,
					ExpedienteEstados.resolucion_firmada,
				].includes(this.Expediente.estado.codigo);
			case Roles.presidente:
				return [
					ExpedienteEstados.ingresado,
					ExpedienteEstados.solicitud_prorroga,
					ExpedienteEstados.cerrado,
				].includes(this.Expediente.estado.codigo);
			case Roles.fiscalizador:
				return [
					ExpedienteEstados.enviado_fiscalizacion,
					// RFC4: expediente devuelto por el Presidente para su corrección
					ExpedienteEstados.en_correccion,
				].includes(this.Expediente.estado.codigo);
			case Roles.prestador:
				return [
					ExpedienteEstados.aprobado,
					ExpedienteEstados.solicitud_prorroga,
					ExpedienteEstados.prorroga_aprobada,
					ExpedienteEstados.prorroga_rechazada,
				].includes(this.Expediente.estado.codigo);
			default:
				return false;
		}
	}
}
